import styled from "styled-components"
import NewsletterImage from "../assets/undraw_mailbox.svg"

const NewsletterImageComponent = styled(NewsletterImage)`
  width: 70%;
  height: 500px;
  display: block;
  margin: 0 0 0 auto;
  & *[fill="#6c63ff"] {
    fill: ${(props) => props.theme.b_color_gradients.b_dark};
  }
  @media (max-width: 600px) {
    width: 100%;
  }
`

export { NewsletterImageComponent }
